import React, {useEffect} from 'react';
import PageTitle from '../../ui/PageTitle/PageTitle';
import useSearchResults from './useSearchResults';
import styles from './SearchResults.module.scss';
import TabsAndSorting from "../../components/ui/TabsAndSorting/TabsAndSorting";
import Filters from "../../components/ui/Filters/Filters";
import FiltersMobile from "../../components/ui/FitlersMobile/FiltersMobile";
import useFilters from "../../hooks/useFilters";
import Pagination from "../../components/ui/Pagination/Pagination";
import TabContent from "../../components/ui/TabContent/TabContent"
import mapping from "../../config/mapping";

const SearchResults = () => {
    const {
        screenWidth,
        handleSelectionClick,
        selectedTabOption,
        handleLearnMore,
        totalPages,
        displayPages,
        currentPage,
        handlePageChange,
        handleNext,
        handlePrevious,
        selectedProductsPerPage,
        selectedProductsSorting,
        setSelectedProductsPerPage,
        setSelectedProductsSorting,
        setCurrentPage,
        search,
        isMobile,
        onPageChange,
        labels,
        searchQuery,
        devices,
        articles,
        support,
        rateplans,
        filterItems,
        setDisplayPages,
        updateURL,
        parametersReady,
        filtersForRequest,
        expandedSubCategories,
        setExpandedSubCategories,
        productSorting,
        lang
    } = useSearchResults();

    const {
        filterRef,
        showMobileFilter,
        setShowMobileFilter,
        SelectedItem,
        handleShowFilterSection,
        expandedCategories,
        toggleSubCategoryExpansion,
        toggleCategoryExpansion,
        clearFilters,
        selectedOptions,
        filters,
        handleFilterOptionChange,
        handleRemoveFilterOption,
        handleRadioFilterOptionChange,
        filtersReady,
        toggleCategorySelection,
        isCheckboxVisible,
        setFiltersReady
    } = useFilters(isMobile, setCurrentPage, filtersForRequest, parametersReady, expandedSubCategories, setExpandedSubCategories,
        selectedTabOption, false, lang);

    useEffect(() => {
        const currentURL = new URLSearchParams(window.location.search);
        const allParams = {};
        for (const [key, value] of currentURL.entries()) {
            allParams[key] = value;
        }
        const unknownVariables = Object.entries(allParams).filter(([key]) =>
            !['size', 'sort', 'page', 'selectedTabOption', 'q', 'id', 'value'].includes(key)
        );
        if (parametersReady && filtersReady && filters?.length === unknownVariables?.length) {
            search(filters);
        }
    }, [selectedProductsPerPage, selectedProductsSorting, currentPage, selectedTabOption, parametersReady, searchQuery, filters, filtersReady])

    const itemsMap = mapping.getItemsMap(devices, rateplans, articles, support);
    return (
        <>
            <div className={styles['container']}>
                <PageTitle
                    titleText={
                        <div className="p1" role="heading">
                            {labels['searchResultsFor']} <span className="selected-word">{screenWidth > 990 ? (searchQuery?.length > 50 ? searchQuery.substring(0, 50) + "..."
                            : searchQuery) : searchQuery?.length > 20 ? searchQuery.substring(0, 20) + "..." : searchQuery}</span>
                        </div>
                    }
                />

                <FiltersMobile
                    isMobile={isMobile}
                    filterRef={filterRef}
                    showMobileFilter={showMobileFilter}
                    setShowMobileFilter={setShowMobileFilter}
                    SelectedItem={SelectedItem}
                    selectedTabOption={selectedTabOption}
                    clearFilters={clearFilters}
                    selectedOptions={selectedOptions}
                    expandedSubCategories={expandedSubCategories}
                    expandedCategories={expandedCategories}
                    filterItems={filterItems}
                    toggleCategoryExpansion={toggleCategoryExpansion}
                    toggleSubCategoryExpansion={toggleSubCategoryExpansion}
                    handleShowFilterSection={handleShowFilterSection}
                    handleRemoveFilterOption={handleRemoveFilterOption}
                    toggleCategorySelection={toggleCategorySelection}
                    handleFilterOptionChange={handleFilterOptionChange}
                    handleRadioFilterOptionChange={handleRadioFilterOptionChange}
                    isCheckboxVisible={isCheckboxVisible}
                    lang={lang}

                />

                <div>
                    <div className="d-flex cardStyle " style={{ padding: '0 10px 5px' }}>
                        {/* LEFT */}
                        <Filters
                            selectedTabOption={selectedTabOption}
                            devices={devices}
                            handleLearnMore={handleLearnMore}
                            screenWidth={screenWidth}
                            handleShowFilterSection={handleShowFilterSection}
                            clearFilters={clearFilters}
                            selectedOptions={selectedOptions}
                            expandedSubCategories={expandedSubCategories}
                            expandedCategories={expandedCategories}
                            filterItems={filterItems}
                            toggleSubCategoryExpansion={toggleSubCategoryExpansion}
                            toggleCategoryExpansion={toggleCategoryExpansion}
                            handleRemoveFilterOption={handleRemoveFilterOption}
                            handleFilterOptionChange={handleFilterOptionChange}
                            handleRadioFilterOptionChange={handleRadioFilterOptionChange}
                            toggleCategorySelection={toggleCategorySelection}
                            isCheckboxVisible={isCheckboxVisible}
                            lang={lang}
                        />

                        <div
                            className={(screenWidth < 1200 || selectedTabOption === 'articles' || selectedTabOption === 'support') ? "navigation-menu-wrap " : "cards-elements"} style={{ padding: '0 15px 5px' }}>
                            <TabsAndSorting screenWidth={screenWidth}
                                            selectedTabOption={selectedTabOption}
                                            devicesItems={devices}
                                            rateplansItems={rateplans}
                                            articlesItems={articles}
                                            supportItems={support}
                                            onTabSelection={handleSelectionClick}
                                            isMobile={isMobile}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            search={search}
                                            handleShowFilterSection={handleShowFilterSection}
                                            updateURL={updateURL}
                                            selectedProductsPerPage={selectedProductsPerPage}
                                            selectedProductsSorting={selectedProductsSorting}
                                            setSelectedProductsSorting={setSelectedProductsSorting}
                                            setSelectedProductsPerPage={setSelectedProductsPerPage}
                                            setFiltersReady={setFiltersReady}
                                            productSorting={productSorting}
                                            clearFilters={clearFilters}
                            />

                            {itemsMap && itemsMap[selectedTabOption] && (
                                <TabContent
                                    selectedTabOption={selectedTabOption}
                                    items={itemsMap[selectedTabOption]}
                                    onLearnMore={handleLearnMore}
                                    labels={labels}
                                />
                            )}

                            {totalPages.length > 1 &&
                                <Pagination
                                    displayPages={displayPages}
                                    onPageChange={onPageChange}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    setDisplayPages={setDisplayPages}
                                    handlePageChange={handlePageChange}
                                    handleNext={handleNext}
                                    handlePrevious={handlePrevious}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SearchResults;
